import { Layer } from 'interfaces/maps.interface';
import { PLACE_SOURCE_TYPES } from 'utils/constants';

export const TOTAL_SUGGESTIONS_ALLOWED = 1;
export const SUGARCANE_SUPPORTED_SEASON_IDS = ['323'];
export const GROUNDNUT_SUPPORTED_SEASON_IDS = ['324'];
export const PADDY_SUPPORTED_SEASON_IDS = ['327'];
export const POTATO_SUPPORTED_SEASON_IDS = ['332'];

export const ALL_LAYERS: Record<string, Layer> = {
	'FARMS-USER_FARM-SUGARCANE_24_PROGRAM_TYPE': {
		PlaceNamespace: 'FARMS',
		PlaceGeometryType: 'INVALID_GEOMETRY_TYPE',
		MinZoomLevel: 16,
		MaxZoomLevel: 19,
		PlaceSourceType: PLACE_SOURCE_TYPES.USER_FARM,
		PlaceVisibleType: 'SUGARCANE_24_PROGRAM_TYPE',
	},
};

export const GROUNDNUT_LAYERS: Record<string, Layer> = {
	'FARMS-USER_FARM-GROUNDNUT_25_PROGRAM_TYPE': {
		PlaceNamespace: 'FARMS',
		PlaceGeometryType: 'INVALID_GEOMETRY_TYPE',
		MinZoomLevel: 16,
		MaxZoomLevel: 19,
		PlaceSourceType: PLACE_SOURCE_TYPES.USER_FARM,
		PlaceVisibleType: 'GROUNDNUT_PROGRAM_TYPE',
	},
};
export const PADDY_LAYERS: Record<string, Layer> = {
	'FARMS-USER_FARM-PADDY_25_PROGRAM_TYPE': {
		PlaceNamespace: 'FARMS',
		PlaceGeometryType: 'INVALID_GEOMETRY_TYPE',
		MinZoomLevel: 16,
		MaxZoomLevel: 19,
		PlaceSourceType: PLACE_SOURCE_TYPES.USER_FARM,
		PlaceVisibleType: 'PADDY_25_PROGRAM_TYPE',
	},
};
export const POTATO_LAYERS: Record<string, Layer> = {
	'FARMS-USER_FARM-POTATO_25_PROGRAM_TYPE': {
		PlaceNamespace: 'FARMS',
		PlaceGeometryType: 'INVALID_GEOMETRY_TYPE',
		MinZoomLevel: 16,
		MaxZoomLevel: 19,
		PlaceSourceType: PLACE_SOURCE_TYPES.USER_FARM,
		PlaceVisibleType: 'POTATO_25_PROGRAM_TYPE',
	},
};

export const getLayersByType = (type: string): Record<string, Layer> => {
	switch (type?.toLowerCase()) {
		case 'groundnut':
			return GROUNDNUT_LAYERS;
		case 'sugarcane':
			return ALL_LAYERS;
		case 'paddy':
			return PADDY_LAYERS;
		case 'potato':
			return POTATO_LAYERS;
		default:
			return {};
	}
};

// Returns supported season IDs by type
export const getSupportedSeasonIdsByType = (type: string): string[] => {
	switch (type?.toLowerCase()) {
		case 'groundnut':
			return GROUNDNUT_SUPPORTED_SEASON_IDS;
		case 'sugarcane':
			return SUGARCANE_SUPPORTED_SEASON_IDS;
		case 'paddy':
			return PADDY_SUPPORTED_SEASON_IDS;
		case 'potato':
			return POTATO_SUPPORTED_SEASON_IDS;
		default:
			return [];
	}
};
